import { Hero } from "@/components/Hero";
import { Navbar } from "@/components/Navbar";
import { ServicesGrid } from "@/components/ServicesGrid";
import { AboutUs } from "@/components/AboutUs";
import { PricingPlans } from "@/components/PricingPlans";
import { PropertiesPreview } from "@/components/PropertiesPreview";
import { Footer } from "@/components/Footer";
import { Suspense } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Index = () => {
  return (
    <div className="min-h-screen bg-parchment">
      <Suspense fallback={
        <div className="flex items-center justify-center min-h-screen bg-parchment">
          <div className="animate-pulse text-terracotta font-display font-black text-2xl uppercase tracking-[0.5em]">Latam Editorial</div>
        </div>
      }>
        <Navbar />
        <main>
          {/* 1. Hero (B2B focused) */}
          <Hero />
          
          {/* 2. Services Grid (Summary) */}
          <div id="services-grid">
            <ServicesGrid />
          </div>

          {/* 3. Propiedades Destacadas (Preview) */}
          <PropertiesPreview />

          {/* 4. Historia de los Socios (Summary) */}
          <section className="py-24 bg-ink text-parchment relative overflow-hidden">
            <div className="absolute inset-0 opacity-5 grain-texture pointer-events-none" />
            <div className="container mx-auto px-4 text-center relative z-10">
              <span className="text-xs font-black uppercase tracking-[0.5em] text-terracotta mb-8 block">Nuestra Historia</span>
              <h2 className="text-5xl md:text-8xl font-display font-black uppercase italic mb-12 leading-none">
                Tres socios, <br /> <span className="text-terracotta">una misión.</span>
              </h2>
              <p className="text-xl md:text-2xl font-serif italic text-parchment/60 max-w-3xl mx-auto mb-16 leading-relaxed">
                Unimos la experiencia inmobiliaria, la innovación tecnológica y el respaldo legal para crear el ecosistema definitivo para el corredor independiente.
              </p>
              <Link to="/nosotros">
                <Button variant="terracotta" size="lg" className="h-16 px-12 text-xs font-black tracking-widest">CONOCE NUESTRO LEGADO</Button>
              </Link>
            </div>
          </section>

          {/* 5. Planes y Precios (Summary) */}
          <section className="py-24 bg-parchment border-t-2 border-ink">
            <div className="container mx-auto px-4">
              <div className="text-center mb-16">
                <span className="text-xs font-black uppercase tracking-[0.5em] text-terracotta mb-4 block">Inversión en tu Negocio</span>
                <h2 className="text-5xl md:text-7xl font-display font-black uppercase italic text-ink">Planes y Precios</h2>
              </div>
              <PricingPlans />
              <div className="mt-16 text-center">
                <Link to="/planes">
                  <Button variant="outline" className="h-14 px-8 text-xs font-black tracking-widest border-2 border-ink">VER DETALLE DE PLANES</Button>
                </Link>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
